import { CloseIcon, MenuIcon, SketchNoteLogoIcon } from '@sketchnote/icons';
import cn from 'classnames';
import Link from 'next/link';
import * as React from 'react';

const { useState } = React;

export const Header = ({ className }: { className?: string }): JSX.Element => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileProductMenuOpen, setIsMobileProductMenuOpen] = useState(false);

  return (
    <div>
      <div
        className={cn(
          'desktop:hidden tablet:block mobile:block z-200 fixed bg-white w-full',
          className
        )}
      >
        {!isMobileMenuOpen && (
          <div className="flex justify-between py-16 px-24  shadow-xs">
            <Link href={'https://sketchnote.co/'}>
              <a className="flex items-center">
                <SketchNoteLogoIcon className="text-primary-500 text-4xl" />
                <span className="text-primary-800 font-extraBold ml-4 text-xl">sketchnote</span>
              </a>
            </Link>

            <button
              aria-label="menu"
              onClick={() => {
                setIsMobileMenuOpen(true);
              }}
            >
              <MenuIcon />
            </button>
          </div>
        )}
        {isMobileMenuOpen && (
          <div className="w-screen h-screen">
            <div className="fixed flex flex-col overflow-visible object-contain w-screen h-screen  p-24  bg-blue-800 text-white z-200">
              <div className="flex justify-between h-64">
                <SketchNoteLogoIcon className="text-primary-500 text-4xl" />
                <CloseIcon
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    setIsMobileProductMenuOpen(false);
                  }}
                  className="text-xs mt-6 text-gray-500"
                />
              </div>

              <div className="mt-auto h-107  bg-primary-800 w-full">
                <Link href={'/signin'}>
                  <a className="block w-full mb-12 py-13 text-center bg-primary-700 text-white rounded-sm">
                    Log in
                  </a>
                </Link>
                <Link href={'/signup'}>
                  <a className="block w-full mb-12 py-13 text-center bg-primary-500 text-white rounded-sm">
                    Sign up for free
                  </a>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className={cn(
          'desktop:inline laptop:hidden tablet:hidden mobile:hidden fixed z-200 w-full',
          className
        )}
      >
        <div className="flex justify-between py-16 desktop:px-64 laptop:px-48 bg-white shadow-xs">
          <Link href={'https://sketchnote.co/'}>
            <a className="flex items-center">
              <SketchNoteLogoIcon className="text-primary-500 text-4xl" />
              <span className="text-primary-800 font-extraBold ml-4 text-xl">sketchnote</span>
            </a>
          </Link>
          {/* {authData?.authentication !== 'authorised' && ( */}
          <div className="flex text-gray-500 text-sm justify-between">
            <Link href={'/signin'}>
              <a className="text-center mt-2 ml-32 py-6 px-16 bg-blue-100 text-blue-500 rounded-sm inline-block">
                Log in
              </a>
            </Link>
            <Link href={'/signup'}>
              <a className="text-center mt-2 ml-12 py-6 px-16 bg-blue-500 text-white rounded-sm inline-block">
                Sign up for free
              </a>
            </Link>
          </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};
